import * as domHelpers from "../../scripts/utils/domHelpers.js";

class Basket {
    constructor() {
        this.markupItemsPanelAsTable();
    }

    // Convert the items panel to a table
    // Some elements from Spektrix may not be handled by this function. If elements are missing
    // from the table markup, you may need to add suppport for them to this function.
    markupItemsPanelAsTable() {
        // Find the container with the items
        const container = document.getElementById(
            "ctl00_ContentPlaceHolder_ItemsPanel",
        );

        if (!container) {
            return;
        }

        const items = container.querySelectorAll("dl.Items > dt.Item");

        // Create the table and headers
        const table = document.createElement("table");
        table.id = "ctl00_ContentPlaceHolder_ItemsUpdate";
        table.classList.add("Items");

        const thead = document.createElement("thead");
        const headerRow = document.createElement("tr");

        // Define headers
        const headers = [container.querySelector(".Items dt.Header")];
        const columns = [];

        container.querySelectorAll(".Header .Breakdown li").forEach((li) => {
            headers.push(li);
            columns.push(li.getAttribute("class"));
        });

        headers.forEach((header) => {
            const th = document.createElement("th");
            th.setAttribute("class", header.getAttribute("class"));
            th.textContent = header.textContent;
            headerRow.appendChild(th);
        });

        thead.appendChild(headerRow);
        table.appendChild(thead);

        // Build the table body
        const tbody = document.createElement("tbody");

        items.forEach((item) => {
            const itemName =
                item.querySelector("span")?.textContent ?? item.textContent;
            const dd = item.nextElementSibling;

            const details =
                dd.querySelector(".Details")?.outerHTML ??
                dd.querySelector("p span")?.textContent ??
                "";
            const viewDetails =
                dd.querySelector(".ViewDetails")?.outerHTML ?? "";
            const giftTo = dd.querySelector(".Breakdown .To")?.innerHTML;

            const buttons = dd.querySelector(".Buttons")?.outerHTML ?? "";

            // Build the item
            const row = document.createElement("tr");

            const itemHeaderCell = document.createElement("td");
            itemHeaderCell.innerHTML = `
                <div class="Item Instance">
                    <h3 class="title">${itemName}</h3>
                    ${details}
                    ${viewDetails}
                    ${giftTo ?? ""}
                    ${buttons}
                </div>
            `;
            row.appendChild(itemHeaderCell);

            const tableCells = dd.querySelectorAll(".Breakdown li");

            columns.forEach((column) => {
                const cell = Array.from(tableCells).find((cell) =>
                    cell.classList.contains(column),
                );

                if (!cell) {
                    const emptyCell = document.createElement("td");
                    emptyCell.setAttribute("class", column);
                    row.appendChild(emptyCell);
                } else {
                    let cellValue =
                        cell.querySelector(".Value")?.textContent ?? "";

                    if (cellValue === "") {
                        console.log(cell.textContent);

                        cellValue = cell.textContent;
                    }

                    const cellValueCell = document.createElement("td");
                    cellValueCell.setAttribute(
                        "class",
                        cell.getAttribute("class"),
                    );
                    cellValueCell.textContent = cellValue;

                    row.appendChild(cellValueCell);
                }
            });

            tbody.appendChild(row);
        });

        const tfoot = document.createElement("tfoot");

        // Append the Footer rows
        const footerRows = [];

        container.querySelectorAll("dd.Footer .Breakdown li").forEach((li) => {
            footerRows.push(li);
        });

        footerRows.forEach((row) => {
            const rowLabel = row.querySelector(".Label");
            const rowLabelText = rowLabel?.textContent.replace(/:/g, "") ?? "";
            const rowValue = row.querySelector(".Value");

            const footerRow = document.createElement("tr");
            footerRow.setAttribute("class", row.getAttribute("class"));

            const footerLabelCell = document.createElement("td");
            footerLabelCell.setAttribute("colspan", headers.length - 1);
            footerLabelCell.setAttribute(
                "class",
                rowLabel.getAttribute("class"),
            );
            footerLabelCell.classList.add("type-input-label");
            footerLabelCell.textContent = rowLabelText;
            footerRow.appendChild(footerLabelCell);

            const footerTotalCell = document.createElement("td");
            footerTotalCell.setAttribute(
                "class",
                rowValue.getAttribute("class"),
            );
            footerTotalCell.textContent = rowValue?.textContent ?? "";
            footerRow.appendChild(footerTotalCell);

            tfoot.appendChild(footerRow);
        });

        table.appendChild(tbody);
        table.appendChild(tfoot);

        // Insert the table into the DOM
        container.innerHTML = ""; // Clear the original content
        container.appendChild(table);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const pageSelector = document.querySelector(".Basket2");

    if (pageSelector) {
        new Basket();
    }
});
